import { useState, useCallback, useMemo } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import {
  CARRIER_TRACKING_URL_TYPE,
  CARRIER_PHONE_TYPE,
} from '@pperform/pp-constants/widgetConfigs';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useCarrierInformation } from '../../context';
import { TooltipContent } from './CarrierInformation.styles';

export const useCarrierInforTrackingDetail = () => {
  const { t } = useTranslation();
  const { trackingDetailsBox } = usePTPConfigContext();

  const [isShowTooltip, toggleTooltip] = useState(false);

  // Carrier phone config
  const { carrierPhone, carrierTrackingUrl, shouldShowCarrierName } =
    trackingDetailsBox;

  // Use the new carrier information hook
  const {
    isShowingSwitcher,
    isShowCurrentCarrier,
    isCurrentCarrierAsDestinationCarrier,
    switchCarrier,
    carrierInfo,
    isLoading,
  } = useCarrierInformation();

  const carrierPhoneNumber = carrierInfo?.phone;
  const isShowCarrierPhoneIcon =
    carrierPhoneNumber &&
    carrierPhone?.isEnabled &&
    carrierPhone?.type === CARRIER_PHONE_TYPE.PHONE_ICON;
  const isShowCarrierPhoneNumber =
    carrierPhoneNumber &&
    carrierPhone?.isEnabled &&
    carrierPhone?.type === CARRIER_PHONE_TYPE.PHONE_NUMBER;

  const isRedirectCarrierTrackingUrl =
    carrierTrackingUrl?.isEnabled &&
    carrierTrackingUrl?.type === CARRIER_TRACKING_URL_TYPE.REDIRECT_ICON;
  const isHyperlinkCarrierTrackingUrl =
    carrierTrackingUrl?.isEnabled &&
    carrierTrackingUrl?.type === CARRIER_TRACKING_URL_TYPE.HYPERLINK;

  const onSwitchCarrier = useCallback(() => {
    // Close tooltip immediately
    toggleTooltip(false);
    switchCarrier();
  }, [switchCarrier]);

  const handleToggleTooltip = () => {
    toggleTooltip((prev) => !prev);
  };

  // Memoize tooltip content to avoid re-creating on every render
  const tooltipContent = useMemo(() => {
    const getTooltip = () => {
      if (isShowCurrentCarrier) {
        return t('SEE_ORIGIN_CARRIER');
      }

      if (isCurrentCarrierAsDestinationCarrier) {
        return t('SEE_DESTINATION_CARRIER');
      }

      return t('SEE_CURRENT_CARRIER');
    };

    return (
      <TooltipContent onClick={onSwitchCarrier}>
        <span>{getTooltip()}</span>
      </TooltipContent>
    );
  }, [
    isCurrentCarrierAsDestinationCarrier,
    isShowCurrentCarrier,
    onSwitchCarrier,
    t,
  ]);

  return {
    isLoading,
    tooltipContent,
    handleToggleTooltip,
    carrierConfig: {
      isRedirectCarrierTrackingUrl,
      isHyperlinkCarrierTrackingUrl,
      isShowCarrierPhoneNumber,
      isShowCarrierPhoneIcon,
      isShowCarrierName: shouldShowCarrierName,
      isShowingSwitcher,
      isShowTooltip,
    },
    carrierInfo,
  };
};
